<template>
  <div id="app" ref="globalHost" class="blk fp global-host ys position-relative">
    <nav-bar />
    <div id="hero-area" class="main-content hero-area-bg container-full-bg overflow-auto">
      <div class="container">
        <div class="row justify-content-between">

          <div class="col">
            <div class="contents page-header-inner home-text text-left mb-5">

              <!-- Contact Information -->
              <!--              <div class="contact-info mt-4">
                              <div class="row">
                                <div class="col-md-6">
                                  <p><span class="font-weight-600">Email: </span>{{ ADDRESS_DATA.email }}</p>
                                  <p><span class="font-weight-600">Address: </span> {{ ADDRESS_DATA.location }}</p>
                                </div>
                                <div class="col-md-6 text-right">
                                  <p class="text-right"><span class="font-weight-600">Phone: </span> {{ ADDRESS_DATA.phone }}<span class="mx-3 user-select-none select-none">|</span>{{ADDRESS_DATA.secondaryPhone}}</p>

                                  <p class="text-right"><span class="font-weight-600">Correspondence: </span> {{ ADDRESS_DATA.correspondence}}</p>
                                </div>
                              </div>

                              <div class="social-links mt-2">
                                <a v-if="resumeData.personalInfo.website" :href="resumeData.personalInfo.website" target="_blank" class="social-link">
                                  <i class="fas fa-globe"></i> {{ resumeData.personalInfo.website }}
                                </a>
                                <a v-if="resumeData.personalInfo.linkedin" :href="resumeData.personalInfo.linkedin" target="_blank" class="social-link">
                                  <i class="fab fa-linkedin"></i> LinkedIn
                                </a>
                                <a v-if="resumeData.personalInfo.github" :href="resumeData.personalInfo.github" target="_blank" class="social-link">
                                  <i class="fab fa-github"></i> GitHub
                                </a>
                              </div>
                            </div>-->

              <!-- Professional Summary -->
              <div class="professional-summary my-6">
                <h4 class="section-title">About Me</h4>
                <p class="">
                  {{ resumeData.professionalSummary }}
                </p>
              </div>

              <!-- Live CV — embedded straight from Google Docs so it never goes stale -->
              <div class="live-cv my-6">
                <div class="cv-header d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
                  <h4 class="section-title mb-0">My CV</h4>
                  <div class="cv-actions d-flex flex-wrap gap-2">
                    <a :href="resumeDoc.pdfUrl"
                       class="btn btn-sm btn-primary border-0 px-3"
                       @click="logCvClick('Download CV PDF')">Download PDF</a>
                    <a :href="resumeDoc.shareUrl"
                       target="_blank" rel="noopener noreferrer"
                       class="btn btn-sm btn-outline-light px-3"
                       @click="logCvClick('Open CV in Google Docs')">Open in Google Docs</a>
                  </div>
                </div>
                <div class="cv-embed">
                  <iframe
                    :src="resumeDoc.previewUrl"
                    title="Kobina Koomson — CV (live from Google Docs)"
                    loading="lazy"
                    referrerpolicy="no-referrer"
                    allowfullscreen
                  ></iframe>
                </div>
                <p class="cv-note text-muted mt-2 mb-0">
                  Embedded live from Google Docs, so it's always the latest version.
                  Trouble viewing it?
                  <a :href="resumeDoc.shareUrl" target="_blank" rel="noopener noreferrer">Open it directly</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mini-footer />
  </div>
</template>

<script>
import NavBar from "@/layout-components/nav.vue";
import MiniFooter from "@/layout-components/mini-footer.vue";
import resumeData, { RESUME_DOC } from "@/config/resume-data.js";
import { ADDRESS_DATA } from "@/config/address";
import { logGoogleAnalyticsClickEvent } from "@/helpers/utils";

export default {
  name: "resume",
  computed: {
    ADDRESS_DATA () {
      return ADDRESS_DATA;
    }
  },
  components: { NavBar, MiniFooter },
  data () {
    return {
      title: "George Kobina Koomson - Resume",
      resumeData: resumeData,
      resumeDoc: RESUME_DOC
    };
  },
  methods: {
    logCvClick (label) {
      logGoogleAnalyticsClickEvent({
        category: "Resume",
        action: "Click",
        label
      });
    }
  },
  mounted () {
    document.title = this.title;
  }
};
</script>
<style scoped lang="scss">
@import "../assets/styles/scss/colors";
@import "../assets/styles/scss/media-queries";

.my-name {
  font-size: 32px;
  margin-bottom: 15px;

  .official-name {
    //color: $accent-color;
  }
}

.skill-highlight {
  background-color: rgba($accent-color, 0.2);
  //color: $accent-color;
  padding: 5px 10px;
}

.contact-info {
  //p {
  //  margin-bottom: 8px;
  //  display: flex;
  //  align-items: center;
  //
  //  i {
  //    margin-right: 10px;
  //    color: $accent-color;
  //    width: 20px;
  //  }
  //}

  .social-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .social-link {
      display: inline-flex;
      align-items: center;
      background-color: rgba($accent-color, 0.1);
      //color: $accent-color;
      padding: 5px 12px;
      border-radius: 20px;
      font-size: 14px;
      text-decoration: none;
      transition: all 0.3s ease;

      i {
        margin-right: 8px;
      }

      &:hover {
        background-color: $accent-color;
        //color: white;
      }
    }
  }
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
  position: relative;
  padding-bottom: 8px;
  //color: $accent-color;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 2px;
    background-color: $accent-color;
  }
}

.skills-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .skill-tag {
    background-color: rgba($accent-color, 0.1);
    //color: $accent-color;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 14px;
  }
}

.skill-category {
  margin-bottom: 15px;

  .skill-category-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    //color: $accent-color;
  }
}

.live-cv {
  .cv-embed {
    background-color: var(--card-bg, #101010);
    border-radius: 8px;
    overflow: hidden;

    iframe {
      display: block;
      width: 100%;
      height: 85vh;
      min-height: 640px;
      border: 0;
      background-color: #fff;
    }
  }
}

// the Google Doc is cross-origin, so in dark mode restyle it optically:
// invert the white page to a soft dark grey and hue-rotate so colours keep
// their hue instead of flipping to their complement
:root.dark .live-cv .cv-embed iframe,
:root[data-theme="dark"] .live-cv .cv-embed iframe {
  filter: invert(0.906) hue-rotate(180deg);
}

.live-cv {

  .cv-note {
    font-size: 14px;

    a {
      text-decoration: underline;
    }
  }
}

</style>
